import { render, staticRenderFns } from "./PageTag.vue?vue&type=template&id=37ba7ac3&scoped=true&"
import script from "./PageTag.vue?vue&type=script&lang=js&"
export * from "./PageTag.vue?vue&type=script&lang=js&"
import style0 from "./PageTag.vue?vue&type=style&index=0&id=37ba7ac3&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/.pnpm/vue-loader@15.10.0_enyi6aqizbgycdmugvkasw26ru/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37ba7ac3",
  null
  
)

export default component.exports